module.exports = __webpack_public_path__ + "img/group124.98e37fde.png";